<!-- SitesOverview.vue -->
<script lang="ts">
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import MapComponent from '@/components/MapComponent.vue'
import SiteListVue from '@/components/SiteList.vue'
// import { sitesStatic } from '../composables/SiteList'
import { useSites } from '@/composables/useSites'
import { Vector } from 'ol/source'
import { Feature } from 'ol'
import { Point } from 'ol/geom'
import Polygon from 'ol/geom/Polygon.js'
import { Style, Icon } from 'ol/style'
import { Circle as CircleStyle, Fill, Stroke } from 'ol/style'
import { Vector as VectorLayer } from 'ol/layer'
import { fromLonLat } from 'ol/proj'
import type { Extent } from 'ol/extent'
import { useMapStore } from '@/stores/mapStore'
import { isEmpty as isExtentEmpty } from 'ol/extent'

import { useRouter } from 'vue-router'
import { useDrawer } from '@/composables/useDrawer'
import { useProjects } from '@/composables/useProjects'
import { useDatasets } from '@/composables/useDatasets'

export default defineComponent({
  components: {
    MapComponent,
    SiteListVue
  },

  
//   const info = document.getElementById('info');

// let currentFeature;
// const displayFeatureInfo = function (pixel, target) {
//   const feature = target.closest('.ol-control')
//     ? undefined
//     : map.forEachFeatureAtPixel(pixel, function (feature) {
//         return feature;
//       });
//   if (feature) {
//     info.style.left = pixel[0] + 'px';
//     info.style.top = pixel[1] + 'px';
//     if (feature !== currentFeature) {
//       info.style.visibility = 'visible';
//       info.innerText = feature.get('ECO_NAME');
//     }
//   } else {
//     info.style.visibility = 'hidden';
//   }
//   currentFeature = feature;
// };

// map.on('pointermove', function (evt) {
//   if (evt.dragging) {
//     info.style.visibility = 'hidden';
//     currentFeature = undefined;
//     return;
//   }
//   displayFeatureInfo(evt.pixel, evt.originalEvent.target);
// });

// map.on('click', function (evt) {
//   displayFeatureInfo(evt.pixel, evt.originalEvent.target);
// });

// map.getTargetElement().addEventListener('pointerleave', function () {
//   currentFeature = undefined;
//   info.style.visibility = 'hidden';
// });
  setup() {
    // Function to modify the site-info box which displays the site name when hovering over a site

    const { sites, fetchItems, patchSiteVisibility } = useSites()
    const useProjectsInterface = useProjects()
    const hoveredSiteName = ref<string | null>(null)
    const showHiddenSites = ref(false)
    const displayedSites = computed(() => {
      if (showHiddenSites.value) {
        return sites.value
      }
      return sites.value.filter((site) => site.visible !== false)
    })
 

    const router = useRouter()

    const handleSiteHover = (siteName: string) => {
      hoveredSiteName.value = siteName
    }

    const handleSiteUnhover = () => {
      hoveredSiteName.value = null
    }

    const sortByVisibility = () => {
      sites.value.sort((a: any, b: any) => {
        if (a.visible && !b.visible) {
          return -1
        }
        if (!a.visible && b.visible) {
          return 1
        }
        return 0
      })
    }

    const handleToggleShowHiddenSites = () => {
      showHiddenSites.value = !showHiddenSites.value
    }

    const handleToggleSiteVisibility = async (siteToToggle: { id?: number; visible?: boolean }) => {
      const nextVisible = siteToToggle.visible === false
      siteToToggle.visible = nextVisible
      sortByVisibility()

      if (!siteToToggle.id) {
        return
      }

      try {
        await patchSiteVisibility(siteToToggle.id, nextVisible)
      } catch (error) {
        console.error('Failed to persist site visibility:', error)
        siteToToggle.visible = !nextVisible
        sortByVisibility()
      }
    }
    onMounted(
      
      async () => {
        const siteInfoBox = document.getElementById('mapInfo')

        const modifySiteInfoBox = (siteName: string) => {
          if (siteInfoBox) {
            siteInfoBox.innerHTML = siteName
          }
        }

        await fetchItems()
        await useProjectsInterface.fetchProjects()

        const markSiteVisibleIfUnset = (siteId: number) => {
          const site = sites.value.find((candidate) => candidate.id === siteId)
          if (!site) {
            return
          }
          if (site.visible === undefined || site.visible === null) {
            site.visible = true
          }
        }

        for (const project of useProjectsInterface.projects.value) {
          console.log('Project:', project)
          // if project priority is 1, then set the site as visible
          if (project.priority === 1) {
            const siteId = project.area_of_interest
            console.log('Site ID:', siteId)
            if (typeof siteId === 'number') {
              markSiteVisibleIfUnset(siteId)
            }
          }
          // if theres an available psi dataset, set the site as visible
          const siteName = sites.value.find((site) => site.id === project.area_of_interest)?.name
          console.log('Site name:', siteName)
          if (!siteName) {
            console.error('Site name not found')
            continue
          }
          const datasetsInterface = useDatasets(siteName)
          datasetsInterface.fetchDatasets().then(() => {
            if (datasetsInterface.datasets.value.length > 0) {
              if (typeof project.area_of_interest === 'number') {
                markSiteVisibleIfUnset(project.area_of_interest)
              }
              sortByVisibility()
            }
          })
        }

        // sort the active sites to the top
        sortByVisibility()

        // sort every half second
        setInterval(() => {
          sortByVisibility()
        }, 500)

        console.log(sites)
        const sitesStatic = sites.value
        console.log(sitesStatic)
        modifySiteInfoBox('None!')
        const mapStore = useMapStore()
        // break if map is not initialized
        if (!mapStore.map) {
          console.error('Map not initialized')
          return
        }

        const pinSvg = (fillColor: string) =>
          `data:image/svg+xml;utf8,${encodeURIComponent(
            `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2C8.4 2 5.5 4.9 5.5 8.5c0 5.1 6.5 13.5 6.5 13.5s6.5-8.4 6.5-13.5C18.5 4.9 15.6 2 12 2z" fill="${fillColor}" stroke="#ffffff" stroke-width="1.4"/><circle cx="12" cy="8.5" r="2.4" fill="#ffffff"/></svg>`
          )}`

        const PIN_SCALE = 2
        const siteFeaturesByName: Record<string, Feature[]> = {}

        const isSiteDisplayed = (site: { visible?: boolean }) =>
          showHiddenSites.value || site.visible !== false

        const getFeatureRenderPriority = (feature: Feature) => {
          const featureName = feature.get('name') as string
          const featureType = feature.get('featureType') as 'footprint' | 'marker'

          const hoveredPriority = hoveredSiteName.value === featureName ? 100 : 0
          const typePriority = featureType === 'marker' ? 10 : 0

          return hoveredPriority + typePriority
        }

        const generateSiteLayer = () => {
          const footprintStyle = (visible: boolean, hovered: boolean) =>
            new Style({
              fill: new Fill({
                color: hovered
                  ? 'rgba(255, 255, 255, 0.2)'
                  : 'rgba(255, 255, 255, 0.1)'
              }),
              stroke: new Stroke({
                color: hovered
                  ? 'rgba(255, 215, 64, 1)'
                  : 'rgba(255, 255, 255, 1)',
                width: hovered ? 2 : 1
              })
            })

          const markerStyle = (visible: boolean, hovered: boolean) =>
            new Style({
              image: new Icon({
                src: pinSvg(hovered ? '#f59e0b' : visible ? '#3b82f6' : '#6b7280'),
                anchor: [0.5, 1],
                scale: PIN_SCALE
              })
            })

          const styleFeature = (feature: Feature) => {
            const featureName = feature.get('name') as string
            const featureType = feature.get('featureType') as 'footprint' | 'marker'
            const visible = Boolean(feature.get('siteVisible'))
            const hovered = hoveredSiteName.value === featureName

            if (!visible && !showHiddenSites.value) {
              feature.setStyle(new Style({}))
              return
            }

            feature.setStyle(
              featureType === 'marker'
                ? markerStyle(visible, hovered)
                : footprintStyle(visible, hovered)
            )
          }

          // Create a vector source and layer
          const vectorSource = new Vector()

          sitesStatic.forEach((sprite: any) => {
              // Geometry format is [north, east, south, west]
              const geomString = sprite.geometry as string | undefined

              let siteExtentCoords: number[][] | null = null

              if (geomString) {
                try {
                  const siteGeometry = geomString
                    .slice(1, geomString.length - 1)
                    .split(',')
                    .map((coord) => parseFloat(coord.trim()))

                  if (siteGeometry.length === 4 && siteGeometry.every((n) => !Number.isNaN(n))) {
                    siteExtentCoords = [
                      [siteGeometry[3], siteGeometry[0]],
                      [siteGeometry[3], siteGeometry[2]],
                      [siteGeometry[1], siteGeometry[2]],
                      [siteGeometry[1], siteGeometry[0]],
                      [siteGeometry[3], siteGeometry[0]]
                    ].map((coord) => fromLonLat(coord))
                  }
                } catch (error) {
                  console.warn('Failed to parse site geometry:', sprite.name, error)
                }
              }

              if (!siteExtentCoords) {
                const lonLat = [sprite.centre_lon as number, sprite.centre_lat as number]
                const center = fromLonLat(lonLat)
                const fallbackSize = 150
                siteExtentCoords = [
                  [center[0] - fallbackSize, center[1] + fallbackSize],
                  [center[0] - fallbackSize, center[1] - fallbackSize],
                  [center[0] + fallbackSize, center[1] - fallbackSize],
                  [center[0] + fallbackSize, center[1] + fallbackSize],
                  [center[0] - fallbackSize, center[1] + fallbackSize]
                ]
              }

              const sitePolygon = new Polygon([siteExtentCoords])
              const centerPoint = new Point(
                fromLonLat([sprite.centre_lon as number, sprite.centre_lat as number])
              )

              const footprintFeature = new Feature({
                geometry: sitePolygon,
                name: sprite.name
              })
              footprintFeature.set('featureType', 'footprint')
              footprintFeature.set('siteVisible', Boolean(sprite.visible))

              styleFeature(footprintFeature)

              const markerFeature = new Feature({
                geometry: centerPoint,
                name: sprite.name
              })
              markerFeature.set('featureType', 'marker')
              markerFeature.set('siteVisible', Boolean(sprite.visible))

              styleFeature(markerFeature)

              siteFeaturesByName[sprite.name] = [footprintFeature, markerFeature]

              if (isSiteDisplayed(sprite)) {
                vectorSource.addFeature(footprintFeature)
                vectorSource.addFeature(markerFeature)
              }
          })

          const vectorLayer = new VectorLayer({
            source: vectorSource,
            renderOrder: (a, b) => {
              const aPriority = getFeatureRenderPriority(a as Feature)
              const bPriority = getFeatureRenderPriority(b as Feature)

              if (aPriority !== bPriority) {
                return aPriority - bPriority
              }

              const aName = (a.get('name') as string) || ''
              const bName = (b.get('name') as string) || ''
              return aName.localeCompare(bName)
            }
          })

          return vectorLayer
        }

        // Add the vector layer to the map
        const mapContainer = mapStore.map
        const mapContainerView = mapContainer.getView()
        if (!mapContainer || !mapContainerView) {
          console.error('Map container not created or view not initialized')
          return
        }
        const vectorLayer = generateSiteLayer()
        const vectorSource = vectorLayer.getSource()
        if (!vectorLayer || !vectorSource) {
          console.error('Vector layer not created')
          return
        }
        mapContainer.addLayer(vectorLayer)

        const syncSiteVisibilityToFeatures = () => {
          for (const site of sites.value) {
            const siteFeatures = siteFeaturesByName[site.name]
            if (!siteFeatures) {
              continue
            }

            const shouldDisplay = isSiteDisplayed(site)
            siteFeatures.forEach((feature) => {
              feature.set('siteVisible', Boolean(site.visible))

              const hasFeature = vectorSource.hasFeature(feature)
              if (shouldDisplay && !hasFeature) {
                vectorSource.addFeature(feature)
              }

              if (!shouldDisplay && hasFeature) {
                vectorSource.removeFeature(feature)
              }
            })
          }
        }

        const restyleAllFeatures = () => {
          Object.values(siteFeaturesByName).forEach((features) => {
            features.forEach((feature) => {
              const featureName = feature.get('name') as string
              const featureType = feature.get('featureType') as 'footprint' | 'marker'
              const visible = Boolean(feature.get('siteVisible'))
              const hovered = hoveredSiteName.value === featureName

              feature.setStyle(
                featureType === 'marker'
                  ? new Style({
                      image: new Icon({
                        src: pinSvg(hovered ? '#f59e0b' : visible ? '#3b82f6' : '#6b7280'),
                        anchor: [0.5, 1],
                        scale: PIN_SCALE
                      })
                    })
                  : new Style({
                      fill: new Fill({
                        color: hovered ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.1)'
                      }),
                      stroke: new Stroke({
                        color: hovered ? 'rgba(255, 215, 64, 1)' : 'rgba(255, 255, 255, 1)',
                        width: hovered ? 2 : 1
                      })
                    })
              )
            })
          })

          vectorLayer.changed()
        }

        watch(
          [hoveredSiteName, showHiddenSites],
          () => {
            syncSiteVisibilityToFeatures()
            restyleAllFeatures()
          },
          { immediate: true }
        )

        watch(
          sites,
          () => {
            syncSiteVisibilityToFeatures()
            restyleAllFeatures()
          },
          { deep: true }
        )

        // OVERLAY AND INTERACTION
        const hoverThreshold = 100000
        const pixelHoverThreshold: () => number = () => {
          if (!mapContainerView) {
            console.error('Map view not initialized')
            return 1
          }
          const res = mapContainerView.getResolution()
          if (!res) {
            console.error('Resolution not found')
            return 1
          }
          return hoverThreshold / res
        }

        const overlayLayer = new VectorLayer({
          source: new Vector()
        })
        mapContainer.addLayer(overlayLayer)
        const overlaySource = overlayLayer.getSource()
        if (!overlayLayer || !overlaySource) {
          console.error('Overlay source not created')
          return
        }

        // A function to temporarily add a feature to the overlay layer
        const addFeatureToOverlay = (feature: Feature) => {
          overlaySource.addFeature(feature)
          setTimeout(() => {
            overlaySource.removeFeature(feature)
          }, 500)
        }

        // Define a circle style for the hover interaction
        const hoverCircleStyle = new Style({
          zIndex: 123,
          image: new CircleStyle({
            radius: pixelHoverThreshold(),
            fill: new Fill({ color: 'rgba(255, 110, 110, 0.01)' }),
            stroke: new Stroke({
              color: 'rgba(255, 110, 110, 0.5)',
              width: 1
            })
          })
        })

        const displayFeatureInfo = function (pixel: number[], target: any) {
          if (!siteInfoBox) {
            console.error('Site info box not initialized')
            return
          }
          const feature = target.closest('.ol-control')
            ? undefined
            : mapContainer.forEachFeatureAtPixel(pixel, function (feature) {
                return feature;
              });
          if (feature) {
            if (!showHiddenSites.value && feature.get('siteVisible') === false) {
              siteInfoBox.style.visibility = 'hidden';
              hoveredSiteName.value = null
              return
            }
            console.log('Feature:', feature)

            // Get the position of the map in the window
            const mapPosition = mapContainer.getViewport().getBoundingClientRect();


            siteInfoBox.style.left = (pixel[0] + mapPosition.left) + 'px';
            siteInfoBox.style.top = (pixel[1] + mapPosition.top) + 'px';
            siteInfoBox.style.visibility = 'visible';
            // list all properties of the feature
            console.log('Feature properties:', feature.getProperties())
            console.log('Feature name:', feature.get('name'))
            siteInfoBox.innerText = feature.get('name');
            hoveredSiteName.value = feature.get('name') as string
          } else {
            siteInfoBox.style.visibility = 'hidden';
            hoveredSiteName.value = null
          }
        };
        // Define a variable to hold the map interaction for pointermove events
        // Listen for pointermove events on the map
        mapContainer.on('pointermove', (event) => {
          if (!mapContainerView) {
            console.error('Map view not initialized')
            return
          }
          if (!siteInfoBox)
            return

          if (event.dragging) {
            siteInfoBox.style.visibility = 'hidden';
            return;
          }
          displayFeatureInfo(event.pixel, event.originalEvent.target);
          // Get the coordinates of the pointer event
          // const coords = event.coordinate
          // modifySiteInfoBox('-')
          // Iterate over the spriteCoordinates to check if the pointer is over any of them
          // sitesStatic.forEach(() => {
          //   const pixel = mapContainer.getPixelFromCoordinate(coords)
          //   const feature = vectorSource.getClosestFeatureToCoordinate(coords)
          //   if (feature && pixel) {
          //     const geom = feature.getGeometry()
          //     if (!geom) {
          //       console.error('Geometry not found')
          //       return
          //     }
          //     // Calculate the distance between the pointer and the feature's center
          //     const distance = Math.sqrt(
          //       Math.pow(coords[0] - geom.getCoordinates()[0], 2) +
          //         Math.pow(coords[1] - geom.getCoordinates()[1], 2)
          //     )
          //     // Check if the pointer is within the threshold of the feature
          //     if (distance <= hoverThreshold) {
          //       // console.log('Hovered over sprite:', feature);
          //       modifySiteInfoBox(feature?.get('name'))
          //       // Draw a circle around the feature in the mapInstance
          //       const circle = new Feature({
          //         geometry: new Point(geom.getCoordinates())
          //       })
          //       circle.setStyle(hoverCircleStyle)
          //       addFeatureToOverlay(circle)
          //       return
          //     }
          //   }
          // })
        })

        // Define a click interaction for the map
        mapContainer.on('click', (event) => {
          const target = event.originalEvent.target
          const pixel = event.pixel
          const feature = target.closest('.ol-control')
            ? undefined
            : mapContainer.forEachFeatureAtPixel(pixel, function (feature) {
                return feature;
              });
          if (feature) {
            if (!showHiddenSites.value && feature.get('siteVisible') === false) {
              return
            }
            console.log('Feature:', feature)
            console.log('Feature name:', feature.get('name'))
            // redirect to site page
            // window.location.href = '/site/' + feature?.get('name')
            router.push(`/site/${feature?.get('name')}`)
          } else {
            console.log('No feature found')
          }


          // // Get the coordinates of the pointer event
          // const coords = event.coordinate
          // // Iterate over the spriteCoordinates to check if the pointer is over any of them
          // sitesStatic.forEach(() => {
          //   const pixel = mapContainer.getPixelFromCoordinate(coords)
          //   const feature = vectorSource.getClosestFeatureToCoordinate(coords)
          //   const geom = feature.getGeometry()
          //   if (!geom) {
          //     console.error('Geometry not found')
          //     return
          //   }

          //   if (feature && pixel) {
          //     // Calculate the distance between the pointer and the feature's center
          //     const distance = Math.sqrt(
          //       Math.pow(coords[0] - geom.getCoordinates()[0], 2) +
          //         Math.pow(coords[1] - geom.getCoordinates()[1], 2)
          //     )
          //     // Check if the pointer is within the threshold of the feature
          //     if (distance <= hoverThreshold) {
          //       // console.log('Clicked on sprite:', feature);
          //       // redirect to site page
          //       window.location.href = '/site/' + feature?.get('name')
          //       return
          //     }
          //   }
          // })
        })

        // modifySiteInfoBox('-')

        // get the extent of the vector source
        const extent: Extent = vectorSource.getExtent()
        if (!isExtentEmpty(extent)) {
          console.log('Extent:', extent)
          const padding = 100000
          const paddedExtent = [
            extent[0] - padding,
            extent[1] - padding,
            extent[2] + padding,
            extent[3] + padding
          ]
          mapContainer.getView().fit(paddedExtent)
        }
      } // end of onMounted
    ) // end of onMounted

    return {
      displayedSites,
      hoveredSiteName,
      handleSiteHover,
      handleSiteUnhover,
      showHiddenSites,
      handleToggleShowHiddenSites,
      handleToggleSiteVisibility
    }
  } // end of setup
})
</script>

<template>
  <!-- Two column divs flex -->
  <div class="flex">
    <div class="w-1over3">
      <SiteListVue
        :sites="displayedSites"
        :showHiddenSites="showHiddenSites"
        :hoveredSiteName="hoveredSiteName || undefined"
        @site-hover="handleSiteHover"
        @site-unhover="handleSiteUnhover"
        @toggle-show-hidden-sites="handleToggleShowHiddenSites"
        @toggle-site-visibility="handleToggleSiteVisibility"
      />
    </div>
    <div class="w-2over3">
      <!-- <div id="site-info">None</div> -->
      <MapComponent />
    </div>
  </div>
</template>
